<template>
	<el-container class="bg">
		<el-header class="header">
			<p class="webName"><img class="logoImg" src="../assets/logoImg.png" /></p>
			<el-dropdown placement="bottom-start" @command="dropdownClick">
				<span class="userName el-dropdown-link">
					{{ userName }}
					<i class="arrowDownI el-icon-arrow-down"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="logOut">{{ $t('message.logOutText') }}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</el-header>
		<el-container class="bodyer">
			<el-aside width="160px" class="aside" v-if="menuList.length !== 1">
				<el-menu :default-active="defaultActive" background-color="#FFFFFF" text-color="#333333" active-text-color="#ffffff" router>
					<!--  @select="pageSelect" -->
					<el-menu-item v-for="(menu, index) in menuList" :key="menu.index" :index="menu.index" :route="menu.router">
						<span :class="['asideItemImg', menu.class]"></span>
						<span slot="title" class="asideItemTitle">{{ menu.title }}</span>
					</el-menu-item>
				</el-menu>
			</el-aside>
			<el-main class="main"><router-view></router-view></el-main>
		</el-container>
	</el-container>
</template>

<script>
import { getPermission } from '@/api/getData.js';
export default {
	name: 'homePage',
	data() {
		return {
			userName: '',
			menuList: [],
			index: '0'
		};
	},
	created() {
		console.log('2021');
		let userid = this.$store.state.JHSS.personalUserid;
		if (!userid) {
			this.$router.push({ path: '/redirect' });
			return;
		}
		this.userName = this.$store.state.JHSS.personalAccount;
		this.getPermission(userid);
	},
	methods: {
		// 退出
		dropdownClick: function(item) {
			if (item === 'logOut') {
				this.$store.commit('setJHSS', {});
				this.$router.push({ path: '/redirect' });
			}
		},
		// 获取用户权限
		async getPermission(userid) {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let param = { USERID: userid };
			let res = await getPermission(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			console.log(res.data.ds);
			// console.log(res.data)
			this.menuList = res.data.ds.map(item => {
				item.index = item.SORTID.toString();
				switch (item.SORTID) {
					case 0:
						item.title = this.$t('message.menuText.custManageTitle');
						item.class = 'custManageIcon';
						item.router = { path: '/custManage' };
						break;
					case 1:
						item.title = this.$t('message.menuText.addManageText');
						item.class = 'addManageIcon';
						item.router = { path: '/addManage' };
						break;
					case 2:
						item.title = this.$t('message.menuText.orderManageTitle');
						item.class = 'orderManageIcon';
						item.router = { path: '/ordersManage' };
						break;
					case 3:
						item.title = this.$t('message.menuText.ordercheckTitle');
						item.class = 'orderCheckManageIcon';
						item.router = { path: '/orderCheck' };
						break;
					case 4:
						item.title = this.$t('message.menuText.signatureFormTitle');
						item.class = 'signatureFormManageIcon';
						item.router = { path: '/signManage' };
						break;
					case 5:
						item.title = this.$t('message.menuText.deliverymanTitle');
						item.class = 'deliverymanManageIcon';
						item.router = { path: '/deliveryManage' };
						break;
					case 6:
						item.title = this.$t('message.menuText.deliveryDetailTitle');
						item.class = 'deliveryDetailIcon';
						item.router = { path: '/deliveryDetail' };
						break;
					case 7:
						item.title = this.$t('message.menuText.distributionStatisticsTitle');
						item.class = 'distributionStatisticsIcon';
						item.router = { path: '/distributionStatistics' };
						break;
					case 8:
						item.title = this.$t('message.menuText.temporaryWorkersTitle');
						item.class = 'temporaryWorkersIcon';
						item.router = { path: '/tempeoraryManage' };
						break;
					case 9:
						item.title = this.$t('message.menuText.containerTitle');
						item.class = 'containerIcon';
						item.router = { path: '/containerInfo' };
						break;
					case 10:
						item.title = this.$t('message.menuText.containerQueryTitle');
						item.class = 'containerIcon';
						item.router = { path: '/containerQuery' };
						break;
					case 11:
						item.title = this.$t('message.menuText.historyOrdersTitle');
						item.class = 'orderManageIcon';
						item.router = { path: '/ordersHistory' };
						break;
					case 12:
						item.title = this.$t('message.menuText.formalWorkersTitle');
						item.class = 'deliverymanManageIcon';
						item.router = { path: '/formalWorkersManage' };
						break;
					case 13:
						item.title = this.$t('message.menuText.reservedCargoManagement');
						item.class = 'reservedCargoManageIcon';
						item.router = { path: '/reservedCargoManagement' };
						break;
					case 14:
						item.title = this.$t('message.menuText.amazonOrderTitle');
						item.class = 'containerIcon';
						item.router = { path: '/amazonOrderManage' };
						break;
					case 15:
						item.title = this.$t('message.menuText.DiaoDuTitle');
						item.class = 'containerIcon';
						item.router = { path: '/DiaoDuInfo' };
						break;
					case 16:
						item.title = this.$t('message.menuText.orderRecycleBinTitle');
						item.class = 'containerIcon';
						item.router = { path: '/orderRecycleBin' };
						break;
					case 17:
						item.title = this.$t('message.menuText.xiaoBaoTitle');
						item.class = 'containerIcon';
						item.router = { path: '/xiaoBao' };
						break;
					case 18:
						item.title = this.$t('message.menuText.xiaoBaoYuanGongTitle');
						item.class = 'containerIcon';
						item.router = { path: '/XiaoBaoPeo' };
						break;
					case 20:
						item.title = this.$t('message.menuText.ChildAccountTitle');
						item.class = 'containerIcon';
						item.router = { path: '/ChildAccount' };
						break;
					case 22:
						item.title = this.$t('message.menuText.BaoGUoManagerTitle');
						item.class = 'containerIcon';
						item.router = { path: '/BaoGUoManager' };
						break;
					case 23:
						item.title = this.$t('message.menuText.AreaManagerTitle');
						item.class = 'containerIcon';
						item.router = { path: '/AreaManager' };
						break;
					case 24:
						item.title = this.$t('message.menuText.BLTitle');
						item.class = 'containerIcon';
						item.router = { path: '/BL' };
						break;

				}
				return item;
			});
			// this.index = this.menuList[0].SORTID.toString()
			this.pageSelect(this.menuList[0].SORTID.toString());
		},
		pageSelect(index, indexPath) {
			// console.log(index, indexPath)
			// this.index = index
			let route = this.$route.path;
			if (route.includes('homePage')) {
				if (index === '0') {
					this.$router.push({ path: '/custManage' });
				} else if (index === '1') {
					this.$router.push({ path: '/addManage' });
				} else if (index === '2') {
					this.$router.push({ path: '/ordersManage' });
				} else if (index === '3') {
					this.$router.push({ path: '/orderCheck' });
				} else if (index === '4') {
					this.$router.push({ path: '/signManage' });
				} else if (index === '5') {
					this.$router.push({ path: '/deliveryManage' });
				} else if (index === '6') {
					this.$router.push({ path: '/deliveryDetail' });
				} else if (index === '7') {
					this.$router.push({ path: '/distributionStatistics' });
				} else if (index === '8') {
					this.$router.push({ path: '/tempeoraryManage' });
				} else if (index === '9') {
					this.$router.push({ path: '/containerInfo' });
				} else if (index === '10') {
					this.$router.push({ path: '/containerQuery' });
				} else if (index === '11') {
					this.$router.push({ path: '/ordersHistory' });
				} else if (index === '12') {
					this.$router.push({ path: '/formalWorkersManage' });
				} else if (index === '13') {
					this.$router.push({ path: '/reservedCargoManagement' });
				} else if (index === '14') {
					this.$router.push({ path: '/amazonOrderManage' });
				} else if (index === '15') {
					this.$router.push({ path: '/DiaoDuInfo' });
				}else if (index === '16') {
					this.$router.push({ path: '/orderRecycleBin' });
				}else if (index === '17') {
					this.$router.push({ path: '/xiaoBao' });
				}else if (index === '18') {
					this.$router.push({ path: '/XiaoBaoPeo' });
				}else if (index === '20') {
					this.$router.push({ path: '/ChildAccount' });
				}else if (index === '22') {
					this.$router.push({ path: '/BaoGUoManager' });
				}else if (index === '23') {
					this.$router.push({ path: '/AreaManager' });
				}else if (index === '24') {
					this.$router.push({ path: '/BL' });
				}
			}
		}
	},
	computed: {
		defaultActive() {
			let route = this.$route.path;
			if (route.includes('custManage')) {
				return '0';
			} else if (route.includes('addManage')) {
				return '1';
			} else if (route.includes('ordersManage') || route.includes('logisticsManage')) {
				return '2';
			} else if (route.includes('orderCheck') || route.includes('logisticsCheck')) {
				return '3';
			} else if (route.includes('signManage') || route.includes('signOrder') || route.includes('signImg')) {
				return '4';
			} else if (route.includes('deliveryManage')||route.includes('deliveryClockStatistics')) {
				return '5';
			} else if (route.includes('deliveryDetail')) {
				return '6';
			} else if (route.includes('distributionStatistics')) {
				return '7';
			} else if (route.includes('tempeoraryManage') || route.includes('clockStatistics')) {
				return '8';
			} else if (route.includes('containerInfo') || route.includes('containerOrder') || route.includes('noEnterContainer') || route.includes('containerOrderDetail')) {
				return '9';
			} else if (route.includes('containerQuery')) {
				return '10';
			} else if (route.includes('ordersHistory')) {
				return '11';
			} else if (route.includes('formalWorkersManage') || route.includes('formalWorkersClockStatistics')) {
				return '12';
			} else if (route.includes('reservedCargoManagement')) {
				return '13';
			} else if (route.includes('amazonOrder') || route.includes('signInImgList')) {
				return '14';
			} else if (route.includes('DiaoDuInfo')||route.includes('DiaoDuOrder')) {
				return '15';
			}else if (route.includes('orderRecycleBin')) {
				return '16';
			}else if (route.includes('xiaoBao')) {
				return '17';
			}else if (route.includes('XiaoBaoPeo')) {
				return '18';
			}else if (route.includes('ChildAccount')) {
				return '20';
			}else if (route.includes('BaoGUoManager')) {
				return '22';
			}else if (route.includes('AreaManager')) {
				return '23';
			}else if (route.includes('BL')) {
				return '24';
			}
		}
	}
};
</script>

<style scoped>
.bg {
	background: #eef0f5;
}
/* 布局顶部 */
.header {
	height: 72px !important;
	background: #ffffff;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 47px 0 19px;
}
.logoImg {
	width: 125px;
	height: 43px;
}
.userName {
	font-size: 20px;
	color: #333333;
	line-height: 30px;
	/* margin-right: 16px; */
}
.arrowDownI {
	color: #333333;
	margin-left: 16px;
	opacity: 0.8;
}
/* 布局顶部 */
.bodyer {
	height: calc(100% - 72px);
	height: -moz-calc(100% - 72px);
	height: -webkit-calc(100% - 72px);
}
/* 左侧布局 */
.aside {
	padding: 30px 0;
	background: #ffffff;
	box-shadow: 0 0 4px 0 rgba(203, 203, 203, 0.5);
	border-radius: 2px;
}
.el-menu-item {
	height: 68px;
	font-size: 24px;
	padding: 0 36.4px;
	display: flex;
	align-items: center;
}
.asideItemImg {
	flex-shrink: 0;
	display: inline-block;
	width: 18.2px;
	height: 22px;
	margin-right: 12px;
	background-size: 100%;
}
.is-active {
	background: #0048ff !important;
}
.custManageIcon {
	background: url(../assets/custUnSelIcon.svg) no-repeat center;
}
.addManageIcon {
	background: url(../assets/addresseeUnSelIcon.svg) no-repeat center;
}
.orderManageIcon,
.orderCheckManageIcon,
.signatureFormManageIcon,
.reservedCargoManageIcon {
	background: url(../assets/orderUnSelIcon.svg) no-repeat center;
}
.deliverymanManageIcon {
	background: url(../assets/deliverymanUnSelIcon.svg) no-repeat center;
}
.deliveryDetailIcon {
	background: url(../assets/deliveryDetailUnSelIcon.svg) no-repeat center;
}
.distributionStatisticsIcon {
	background: url(../assets/distributionStatisticsUnSelIcon.svg) no-repeat center;
}
.temporaryWorkersIcon {
	background: url(../assets/tempUnSelIcon.svg) no-repeat center;
}
.clockInStatisticsIcon {
	background: url(../assets/clockUnSelIcon.svg) no-repeat center;
}
.containerIcon {
	background: url(../assets/containerUnSelIcon.svg) no-repeat center;
}
.amazonOrderManageIcon {
	background: url(../assets/amazonOrderUnSelIcon.svg) no-repeat center;
}
.asideItemTitle {
	font-size: 15px;
}
.is-active .asideItemTitle {
	color: #ffffff;
}
.is-active .custManageIcon {
	background: url(../assets/custSelIcon.svg) no-repeat center;
}
.is-active .addManageIcon {
	background: url(../assets/addresseeSelIcon.svg) no-repeat center;
}
.is-active .orderManageIcon,
.is-active .orderCheckManageIcon,
.is-active .signatureFormManageIcon,
.is-active .reservedCargoManageIcon {
	background: url(../assets/orderSelIcon.svg) no-repeat center;
}
.is-active .deliverymanManageIcon {
	background: url(../assets/deliverymanSelIcon.svg) no-repeat center;
}
.is-active .deliveryDetailIcon {
	background: url(../assets/deliveryDetailSelIcon.svg) no-repeat center;
}
.is-active .distributionStatisticsIcon {
	background: url(../assets/distributionStatisticsSelIcon.svg) no-repeat center;
}
.is-active .temporaryWorkersIcon {
	background: url(../assets/tempSelIcon.svg) no-repeat center;
}
.is-active .clockInStatisticsIcon {
	background: url(../assets/clockSelIcon.svg) no-repeat center;
}
.is-active .containerIcon {
	background: url(../assets/containerSelIcon.svg) no-repeat center;
}
.is-active .amazonOrderManageIcon {
	background: url(../assets/amazonOrderSelIcon.svg) no-repeat center;
}
/* 左侧布局 */
/* main布局 */
.main {
	padding: 16px 10px 14px 10px;
}
/* main布局 */
</style>
